export default [
  {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    redirect: '/home',
    meta:{
      authPosition: 2,
      authRequired: true,
      deviceRequired: false
    },
    children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue'),
        meta: {
          deviceRequired: true,
          topBanner: true, // 상단 배너 노출 여부
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '대시보드',
              active: true
            }
          ],
          pageTitle: '대시보드'
        }
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: {
          deviceRequired: true,
          topBanner: true, // 상단 배너 노출 여부
          breadcrumb: [
            {
              title: 'dashboard',
              url: '/dashboard'
            },
            {
              title: '대시보드',
              active: true
            }
          ],
          pageTitle: '대시보드'
        }
      },
      // =============================================================================
      // Theme Routes
      // =============================================================================
      {
        path: '/graph-detail/:graphId',
        name: 'graph-detail',
        component: () => import('@/views/graph-detail/Index'),
        meta: {
          deviceRequired: true,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '대시보드',
              active: true
            }
          ],
          pageTitle: '대시보드'
        }
      },
      // 스마트 보고서
      {
        path: '/smart-report',
        name: 'smart-report',
        component: () => import('@/views/smart-report/Index'),
        meta: {
          deviceRequired: true,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '스마트보고서',
              active: true
            }
          ],
          pageTitle: '스마트보고서'
        }
      },

      // 결재
      {
        path: '/approval-write',
        name: 'page-approval-write',
        component: () => import('@/views/approval/ApprovalWrite.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재문서 작성',
              url: {name: 'page-approval-write'},
              active: true
            }
          ],
          pageTitle: '결재문서 작성'
        }
      },
      {
        path: '/approval-request',
        name: 'page-approval-request',
        component: () => import('@/views/approval/ApprovalRequest.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재요청함',
              url: {name: 'page-approval-request'},
              active: true
            }
          ],
          pageTitle: '결재요청함'
        }
      },
      {
        path: '/approval-await',
        name: 'page-approval-await',
        component: () => import('@/views/approval/ApprovalAwait.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재대기함',
              url: {name: 'page-approval-await'},
              active: true
            }
          ],
          pageTitle: '결재대기함'
        }
      },
      {
        path: '/approval-process',
        name: 'page-approval-process',
        component: () => import('@/views/approval/ApprovalProcess.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재진행함',
              url: {name: 'page-approval-process'},
              active: true
            }
          ],
          pageTitle: '결재진행함'
        }
      },
      {
        path: '/approval-complete',
        name: 'page-approval-complete',
        component: () => import('@/views/approval/ApprovalComplete.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '완료문서함',
              url: {name: 'page-approval-complete'},
              active: true
            }
          ],
          pageTitle: '완료문서함'
        }
      },
      {
        path: '/approval-reject',
        name: 'page-approval-reject',
        component: () => import('@/views/approval/ApprovalReject.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '반려문서함',
              url: {name: 'page-approval-reject'},
              active: true
            }
          ],
          pageTitle: '반려문서함'
        }
      },
      {
        path: '/approval-reference',
        name: 'page-approval-reference',
        component: () => import('@/views/approval/ApprovalReference.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '참조/회람문서함',
              url: {name: 'page-approval-reference'},
              active: true
            }
          ],
          pageTitle: '참조/회람문서함'
        }
      },

      // read - sub router
      {
        path: '/approval-await-read',
        name: 'page-approval-await-read',
        component: () => import('@/views/approval/ApprovalRead.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재대기함',
              url: {name: 'page-approval-await'},
              active: true
            }
          ],
          pageTitle: '결재대기함',
          parent: 'page-approval-await'
        }
      },
      {
        path: '/approval-process-read',
        name: 'page-approval-process-read',
        component: () => import('@/views/approval/ApprovalRead.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '결재진행함',
              url: {name: 'page-approval-process'},
              active: true
            }
          ],
          pageTitle: '결재진행함',
          parent: 'page-approval-process'
        }
      },
      {
        path: '/approval-complete-read',
        name: 'page-approval-complete-read',
        component: () => import('@/views/approval/ApprovalRead.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '완료문서함',
              url: {name: 'page-approval-complete'},
              active: true
            }
          ],
          pageTitle: '완료문서함',
          parent: 'page-approval-complete'
        }
      },
      {
        path: '/approval-reject-read',
        name: 'page-approval-reject-read',
        component: () => import('@/views/approval/ApprovalRead.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '결재관리'},
            {
              title: '반려문서함',
              url: {name: 'page-approval-reject'},
              active: true
            }
          ],
          pageTitle: '반려문서함',
          parent: 'page-approval-reject'
        }
      },


      // 프로젝트
      {
        path: '/content/project',
        name: 'content-project',
        component: () => import('@/views/project/ProjectList.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '사업장 바로가기',
              active: true
            }
          ],
          pageTitle: '사업장 바로가기'
        }
      },
      {
        path: '/content/project/create',
        name: 'content-project-create',
        component: () => import('@/views/project/ProjectWrite.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {
              title: '프로젝트',
              active: true
            }
          ],
          pageTitle: 'breadcrumb.content.project.create.title'
        }
      },

      //커뮤니티
      { // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: '/community/businessnews',
        name: 'content-community-businessnews',
        component: () => import('@/views/community/CommunityBusinessnews.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건관리책임자 지시사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건관리책임자 지시사항',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: '/community/businessnews/create',
        name: 'content-community-businessnews-create',
        component: () => import('@/views/community/CommunityBusinessnewsCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건관리책임자 지시사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건관리책임자 지시사항',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: '/community/businessnews/:postId',
        name: 'content-community-businessnews-detail',
        component: () => import('@/views/community/CommunityBusinessnewsDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건관리책임자 지시사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건관리책임자 지시사항',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: '/community/businessnews/:postId/update',
        name: 'content-community-businessnews-update',
        component: () => import('@/views/community/CommunityBusinessnewsUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건관리책임자 지시사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건관리책임자 지시사항',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / 안전보건관리(총괄)책임자 지시사항
        path: '/community/businessnews/:postId/reply',
        name: 'content-community-businessnews-reply',
        component: () => import('@/views/community/CommunityBusinessnewsReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건관리책임자 지시사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건관리책임자 지시사항',
          parent: 'content_community_businessnews'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/community/qna',
        name: 'content-community-qna',
        component: () => import('@/views/community/CommunityQna.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '목록', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/community/qna/create',
        name: 'content-community-qna-create',
        component: () => import('@/views/community/CommunityQnaCreate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '작성', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/community/qna/:postId',
        name: 'content-community-qna-detail',
        component: () => import('@/views/community/CommunityQnaDetail.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '상세', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/community/qna/:postId/update',
        name: 'content-community-qna-update',
        component: () => import('@/views/community/CommunityQnaUpdate.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '수정', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / Q&A
        path: '/community/qna/:postId/reply',
        name: 'content-community-qna-reply',
        component: () => import('@/views/community/CommunityQnaReply.vue'),
        meta: {
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: 'Q&A'},
            {title: '답변', active: true}
          ],
          pageTitle: 'Q&A',
          parent: 'content_community_qna'
        }
      },
      { // 커뮤니티 / 안전보건 주요 일정
        path: '/community/healthinfo',
        name: 'content-community-healthinfo',
        component: () => import('@/views/community/CommunityHealthInfo.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요 일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요 일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요 일정
        path: '/community/healthinfo/create',
        name: 'content-community-healthinfo-create',
        component: () => import('@/views/community/CommunityHealthInfoCreate.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요 일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요 일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요 일정
        path: '/community/healthinfo/:postId',
        name: 'content-community-healthinfo-detail',
        component: () => import('@/views/community/CommunityHealthInfoDetail.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요 일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요 일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요 일정
        path: '/community/healthinfo/:postId/update',
        name: 'content-community-healthinfo-update',
        component: () => import('@/views/community/CommunityHealthInfoUpdate.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요 일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요 일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 안전보건 주요 일정
        path: '/community/healthinfo/:postId/reply',
        name: 'content-community-healthinfo-reply',
        component: () => import('@/views/community/CommunityHealthInfoReply.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '안전보건 주요 일정'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요 일정',
          parent: 'content_community_healthinfo'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/community/unitbusinessnews',
        name: 'content-community-unitbusinessnews',
        component: () => import('@/views/community/CommunityUnitBusinessNews.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/community/unitbusinessnews/create',
        name: 'content-community-unitbusinessnews-create',
        component: () => import('@/views/community/CommunityUnitBusinessNewsCreate.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/community/unitbusinessnews/:postId',
        name: 'content-community-unitbusinessnews-detail',
        component: () => import('@/views/community/CommunityUnitBusinessNewsDetail.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/community/unitbusinessnews/:postId/update',
        name: 'content-community-unitbusinessnews-update',
        component: () => import('@/views/community/CommunityUnitBusinessNewsUpdate.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '구성원 요청사항',
          parent: 'content_community_unitbusinessnews'
        }
      },
      { // 커뮤니티 / 구성원 요청사항
        path: '/community/unitbusinessnews/:postId/reply',
        name: 'content-community-unitbusinessnews-reply',
        component: () => import('@/views/community/CommunityUnitBusinessNewsReply.vue'),
        meta: {
          authPosition: 4,
          deviceRequired: false,
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '커뮤니티'},
            {title: '구성원 요청사항'},
            {title: '목록', active: true}
          ],
          pageTitle: '안전보건 주요 일정',
          parent: 'content_community_unitbusinessnews'
        }
      },

      // 마이페이지
      { // 마이페이지 / 업무현황
        path: '/mypage/workstatus',
        name: 'content-mypage-workstatus',
        component: () => import('@/views/mypage/MyPageWorkStatus.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '업무현황', active: true}
          ],
          pageTitle: '업무현황',
          parent: 'content_mypage_workstatus'
        }
      },
      { // 마이페이지 / 알림
        path: '/mypage/alert',
        name: 'content-mypage-alert',
        component: () => import('@/views/mypage/MyPageAlert.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '알림', active: true}
          ],
          pageTitle: '알림',
          parent: 'content_mypage_alert'
        }
      },
      { // 마이페이지 / 설정
        path: '/mypage/workmanager',
        name: 'content-mypage-workmanager',
        component: () => import('@/views/mypage/MyPageWorkManager.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '설정', active: true}
          ],
          pageTitle: '설정',
          parent: 'content_mypage_workmanager'
        }
      },
      { // 마이페이지 / 설정 / 개인정보변경
        path: '/mypage/info-update',
        name: 'content-mypage-info-update',
        component: () => import('@/views/mypage/MyPageInfoUpdate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '설정'},
            {title: '개인정보변경', active: true}
          ],
          pageTitle: '개인정보변경',
          parent: 'content_mypage_info-update'
        }
      },
      { // 마이페이지 / 설정 / 개인서명관리
        path: '/mypage/sign-update',
        name: 'content-mypage-sign-update',
        component: () => import('@/views/mypage/MyPageSignUpdate.vue'),
        meta: {
          breadcrumb: [
            {
              title: 'home',
              url: '/home'
            },
            {title: '마이페이지'},
            {title: '설정'},
            {title: '개인서명관리', active: true}
          ],
          pageTitle: '개인서명관리',
          activeCode: 'content-mypage-sign-update'
        }
      },

    ]
  },

  // =============================================================================
  // FULL PAGE LAYOUTS
  // =============================================================================
  {
    path: '/pages/:custom',
    component: () => import('@/views/Pages.vue'),
    children: []
  }
]
